module.exports = __webpack_public_path__ + "static/img/ryj.42eb573.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ryj.jpg
// module id = Iz2g
// module chunks = 1